import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiService, toFormData, markAllAsDirty, uploadProgress, toResponseBody, requiredFileType, requiredFileSize } from 'src/app/_services/api.service';
import { Parcel } from 'src/app/_models/parcel';
import { GoogleAnalyticsService } from 'src/app/_services/GoogleAnalytics.service';
@Component({
  selector: 'app-publicRecords',
  templateUrl: './publicRecords.component.html',
  styleUrls: ['./publicRecords.component.scss']
})
export class PublicRecordsComponent implements OnInit{
  progress = 0;
  contactForm: any;
  success = false;
  parcel: Parcel;
  general = false;
  specific = false;

  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService, private google: GoogleAnalyticsService ) {
    this.contactForm = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      phone: [''],
      request : ['', Validators.required],
      email: ['', Validators.required],
      requestType: [''],
      file: ['', [requiredFileType(''), requiredFileSize(10000000)]],
      recaptchaReactive: ['', Validators.required],
      street: '',
      city: '',
      zipCode: '',
      ain:'',
      description:''
    });
    // file: ['', requiredFileType('pdf')],
  }

  resolved(captchaResponse: string) {
    console.log(captchaResponse);
  }



  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }
    toFormData(this.contactForm.value)
    // console.log(this.contactForm)
    // console.log("worked")

    this.apiService.sendForm(toFormData(this.contactForm.value,),'publicrecords').subscribe(res => {
      // console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      // console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

  getAddress( event : Parcel ){
    this.contactForm.get('ain').setValue(event.AIN);
    this.contactForm.get('city').setValue(event.SitusCity);
    this.contactForm.get('street').setValue(event.SitusStreet);
    this.contactForm.get('zipCode').setValue(event.SitusZipCode);
    // console.log(this.contactForm);
    // console.log(event.AIN);
    this.parcel = event;
  }

  //event handler for radio button
  // radioChangeHandler(event:any){
  //   if(this.contactForm.request.value == "general")
  //   {
  //     this.general = true;
  //     this.specific = false;
  //   }
  //   else(this.contactForm.request.value == "specific")
  //   {
  //     this.general = false;
  //     this.specific = true;
  //   }

  // }
  ngOnInit(){
    this.contactForm.get('request').valueChanges
  .subscribe(value => {
    console.log(value);
    if(value == 'general'){
      this.general = true;
      this.specific = false;
      this.contactForm.get('requestType').setValidators(Validators.required);
      this.contactForm.get('street').clearValidators();
      this.contactForm.get('city').clearValidators();
      this.contactForm.get('zipCode').clearValidators();
      this.contactForm.get('ain').clearValidators();
      this.contactForm.get('ain').updateValueAndValidity();
      this.contactForm.get('street').updateValueAndValidity();
      this.contactForm.get('city').updateValueAndValidity();
      this.contactForm.get('zipCode').updateValueAndValidity();
      // console.log(this.contactForm);
    }
    else if (value == 'specific') {
      this.general = false;
      this.specific = true;
      this.contactForm.get('requestType').clearValidators();
      this.contactForm.get('requestType').updateValueAndValidity();
      this.contactForm.get('street').setValidators(Validators.required);
      this.contactForm.get('city').setValidators(Validators.required);
      this.contactForm.get('zipCode').setValidators(Validators.required);
      this.contactForm.get('ain').setValidators(Validators.required);
      // console.log(this.contactForm);
    }
    else {
      this.general = false;
      this.specific = false;
    }
  });
  }


}
